import {
  ITEM_TYPE_MAIL,
  ITEM_TYPE_RESPONDER,
  ITEM_TYPE_FORM,
  ITEM_TYPE_CONFIRMATION_MAIL,
  ITEM_TYPE_PAGE,
  ITEM_TYPE_FORM_SUBTYPE_SUCCESS,
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_SURVEY_THANK_YOU,
  WIZARD_TYPE_FORM,
  WIZARD_TYPE_PAGE,
} from '@client/components/Editor/settings'
import { SECTION_TYPES } from '@client/components/Section/constants'

export const FIELD_TYPES = {
  NULL: 'NULL',
  SHORT_TEXT: 'SHORT_TEXT',
  LONG_TEXT: 'LONG_TEXT',
  SELECT_ONE: 'SELECT_ONE',
  SELECT_MANY: 'SELECT_MANY',
  SCALE: 'SCALE',
}

export const FIELD_TYPES_VALUES = Object.values(FIELD_TYPES)

export const FIELD_TYPES_SERVER = {
  SINGLE_CHOICE: 'single_choice',
  MULTIPLE_CHOICE: 'multiple_choice',
  TEXT: 'text',
  LONG_TEXT: 'long_text',
  NUMBER: 'number',
  EMAIL: 'email',
  PHONE: 'phone',
  URL: 'url',
  SCALE: 'scale',
}

export const INPUT_TYPES = [
  { value: 'text', name: 'input.type.text' },
  { value: 'number', name: 'input.type.number' },
  { value: 'email', name: 'input.type.email' },
  { value: 'tel', name: 'input.type.tel' },
  { value: 'url', name: 'input.type.url' },
]

export const FIELD_TYPES_SERVER_MAP = {
  text: FIELD_TYPES_SERVER.TEXT,
  number: FIELD_TYPES_SERVER.NUMBER,
  email: FIELD_TYPES_SERVER.EMAIL,
  tel: FIELD_TYPES_SERVER.PHONE,
  url: FIELD_TYPES_SERVER.URL,
}

export const FIELD_TYPES_MAPPING = {
  [FIELD_TYPES_SERVER.TEXT]: FIELD_TYPES.SHORT_TEXT,
  [FIELD_TYPES_SERVER.NUMBER]: FIELD_TYPES.SHORT_TEXT,
  [FIELD_TYPES_SERVER.EMAIL]: FIELD_TYPES.SHORT_TEXT,
  [FIELD_TYPES_SERVER.PHONE]: FIELD_TYPES.SHORT_TEXT,
  [FIELD_TYPES_SERVER.URL]: FIELD_TYPES.SHORT_TEXT,
  [FIELD_TYPES_SERVER.LONG_TEXT]: FIELD_TYPES.LONG_TEXT,
  [FIELD_TYPES_SERVER.SINGLE_CHOICE]: FIELD_TYPES.SELECT_ONE,
  [FIELD_TYPES_SERVER.MULTIPLE_CHOICE]: FIELD_TYPES.SELECT_MANY,
  [FIELD_TYPES_SERVER.SCALE]: FIELD_TYPES.SCALE,
}

export const getServerFieldType = (item) => {
  const fieldType = Object.keys(FIELD_TYPES_MAPPING).find(
    (key) => FIELD_TYPES_MAPPING[key] === item.fieldType
  )
  if (fieldType && FIELD_TYPES_MAPPING[fieldType] !== FIELD_TYPES.SHORT_TEXT) {
    return fieldType
  }
  if (fieldType && FIELD_TYPES_MAPPING[fieldType] === FIELD_TYPES.SHORT_TEXT) {
    return FIELD_TYPES_SERVER_MAP[item.settings.inputType]
  }
  return null
}

export const getClientFieldType = (item) => {
  return FIELD_TYPES_MAPPING[item.type]
}

export const BLOCK_TYPES = {
  NULL: 'NULL',
  SECTION: 'SECTION',
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  SHARE: 'SHARE',
  FOLLOW: 'FOLLOW',
  SHARE_V2: 'SHARE_V2',
  FOLLOW_V2: 'FOLLOW_V2',
  BUTTON: 'BUTTON',
  SIMPLE_BUTTON: 'SIMPLE_BUTTON',
  SUBMIT_BUTTON: 'SUBMIT_BUTTON',
  CONFIRM_BUTTON: 'CONFIRM_BUTTON',
  SPACING: 'SPACING',
  DIVIDER: 'DIVIDER',
  HTML: 'HTML',
  FORM: 'FORM',
  VIDEO: 'VIDEO',
  FIELD: 'FIELD',
  TIMER: 'TIMER',
  BANNER: 'BANNER',
  PRODUCT: 'PRODUCT',
}

export const BLOCK_TYPES_PER_ITEM_TYPE = {
  [ITEM_TYPE_MAIL]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
    [BLOCK_TYPES.SHARE]: BLOCK_TYPES.SHARE,
    [BLOCK_TYPES.FOLLOW]: BLOCK_TYPES.FOLLOW,
    [BLOCK_TYPES.SHARE_V2]: BLOCK_TYPES.SHARE_V2,
    [BLOCK_TYPES.FOLLOW_V2]: BLOCK_TYPES.FOLLOW_V2,
    [BLOCK_TYPES.BUTTON]: BLOCK_TYPES.BUTTON,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
    [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
    [BLOCK_TYPES.VIDEO]: BLOCK_TYPES.VIDEO,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
    [BLOCK_TYPES.BANNER]: BLOCK_TYPES.BANNER,
    [BLOCK_TYPES.PRODUCT]: BLOCK_TYPES.PRODUCT,
  },
  [ITEM_TYPE_RESPONDER]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
    [BLOCK_TYPES.SHARE]: BLOCK_TYPES.SHARE,
    [BLOCK_TYPES.FOLLOW]: BLOCK_TYPES.FOLLOW,
    [BLOCK_TYPES.SHARE_V2]: BLOCK_TYPES.SHARE_V2,
    [BLOCK_TYPES.FOLLOW_V2]: BLOCK_TYPES.FOLLOW_V2,
    [BLOCK_TYPES.BUTTON]: BLOCK_TYPES.BUTTON,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
    [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
    [BLOCK_TYPES.BANNER]: BLOCK_TYPES.BANNER,
    [BLOCK_TYPES.PRODUCT]: BLOCK_TYPES.PRODUCT,
  },
  [ITEM_TYPE_FORM]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
    [BLOCK_TYPES.FORM]: BLOCK_TYPES.FORM,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
  },
  [ITEM_TYPE_FORM_SUBTYPE_SUCCESS]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
  },
  [ITEM_TYPE_LANDING_PAGE]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
    [BLOCK_TYPES.SHARE_V2]: BLOCK_TYPES.SHARE_V2,
    [BLOCK_TYPES.FOLLOW_V2]: BLOCK_TYPES.FOLLOW_V2,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
    [BLOCK_TYPES.SIMPLE_BUTTON]: BLOCK_TYPES.SIMPLE_BUTTON,
    [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
    [BLOCK_TYPES.FORM]: BLOCK_TYPES.FORM,
    [BLOCK_TYPES.VIDEO]: BLOCK_TYPES.VIDEO,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
  },
  [ITEM_TYPE_LANDING_PAGE_SUCCESS]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
    [BLOCK_TYPES.SHARE_V2]: BLOCK_TYPES.SHARE_V2,
    [BLOCK_TYPES.FOLLOW_V2]: BLOCK_TYPES.FOLLOW_V2,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
    [BLOCK_TYPES.SIMPLE_BUTTON]: BLOCK_TYPES.SIMPLE_BUTTON,
    [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
    [BLOCK_TYPES.VIDEO]: BLOCK_TYPES.VIDEO,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
  },
  [ITEM_TYPE_SURVEY]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.FIELD]: BLOCK_TYPES.FIELD,
    [BLOCK_TYPES.SUBMIT_BUTTON]: BLOCK_TYPES.SUBMIT_BUTTON,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
  },
  [ITEM_TYPE_SURVEY_THANK_YOU]: {
    [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
    [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
    [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
    [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
    [BLOCK_TYPES.FOLLOW]: BLOCK_TYPES.FOLLOW,
    [BLOCK_TYPES.SHARE_V2]: BLOCK_TYPES.SHARE_V2,
    [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
    [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
    [BLOCK_TYPES.SIMPLE_BUTTON]: BLOCK_TYPES.SIMPLE_BUTTON,
    [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
    [BLOCK_TYPES.TIMER]: BLOCK_TYPES.TIMER,
  },
}

export const BLOCK_TYPES_PER_WIZARD_ITEM_TYPE = {
  [WIZARD_TYPE_FORM]: {
    [ITEM_TYPE_CONFIRMATION_MAIL]: {
      [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
      [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
      [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
      [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
      [BLOCK_TYPES.FOLLOW]: BLOCK_TYPES.FOLLOW,
      [BLOCK_TYPES.BUTTON]: BLOCK_TYPES.BUTTON,
      [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
      [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
      [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
      [BLOCK_TYPES.CONFIRM_BUTTON]: BLOCK_TYPES.CONFIRM_BUTTON,
    },
    [ITEM_TYPE_PAGE]: {
      [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
      [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
      [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
      [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
      [BLOCK_TYPES.SHARE]: BLOCK_TYPES.SHARE,
      [BLOCK_TYPES.FOLLOW_V2]: BLOCK_TYPES.FOLLOW_V2,
      [BLOCK_TYPES.FOLLOW]: BLOCK_TYPES.FOLLOW,
      [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
      [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
      [BLOCK_TYPES.SIMPLE_BUTTON]: BLOCK_TYPES.SIMPLE_BUTTON,
      [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
      [BLOCK_TYPES.VIDEO]: BLOCK_TYPES.VIDEO,
    },
  },
  [WIZARD_TYPE_PAGE]: {
    [ITEM_TYPE_CONFIRMATION_MAIL]: {
      [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
      [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
      [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
      [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
      [BLOCK_TYPES.FOLLOW_V2]: BLOCK_TYPES.FOLLOW_V2,
      [BLOCK_TYPES.BUTTON]: BLOCK_TYPES.BUTTON,
      [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
      [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
      [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
      [BLOCK_TYPES.CONFIRM_BUTTON]: BLOCK_TYPES.CONFIRM_BUTTON,
    },
    [ITEM_TYPE_PAGE]: {
      [BLOCK_TYPES.NULL]: BLOCK_TYPES.NULL,
      [BLOCK_TYPES.SECTION]: BLOCK_TYPES.SECTION,
      [BLOCK_TYPES.TEXT]: BLOCK_TYPES.TEXT,
      [BLOCK_TYPES.IMAGE]: BLOCK_TYPES.IMAGE,
      [BLOCK_TYPES.SHARE_V2]: BLOCK_TYPES.SHARE_V2,
      [BLOCK_TYPES.FOLLOW_V2]: BLOCK_TYPES.FOLLOW_V2,
      [BLOCK_TYPES.SPACING]: BLOCK_TYPES.SPACING,
      [BLOCK_TYPES.DIVIDER]: BLOCK_TYPES.DIVIDER,
      [BLOCK_TYPES.SIMPLE_BUTTON]: BLOCK_TYPES.SIMPLE_BUTTON,
      [BLOCK_TYPES.HTML]: BLOCK_TYPES.HTML,
      [BLOCK_TYPES.VIDEO]: BLOCK_TYPES.VIDEO,
    },
  },
}

export const BLOCK_SECTIONS_PER_ITEM_TYPE = {
  [ITEM_TYPE_MAIL]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.ONECOL]: SECTION_TYPES.ONECOL,
    [SECTION_TYPES.TWOCOL]: SECTION_TYPES.TWOCOL,
    [SECTION_TYPES.THREECOL]: SECTION_TYPES.THREECOL,
    [SECTION_TYPES.PRODUCTSTHREECOL]: SECTION_TYPES.PRODUCTSTHREECOL,
    [SECTION_TYPES.PRODUCTSTWOCOL]: SECTION_TYPES.PRODUCTSTWOCOL,
  },
  [ITEM_TYPE_CONFIRMATION_MAIL]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.ONECOL]: SECTION_TYPES.ONECOL,
    [SECTION_TYPES.TWOCOL]: SECTION_TYPES.TWOCOL,
    [SECTION_TYPES.THREECOL]: SECTION_TYPES.THREECOL,
    [SECTION_TYPES.PRODUCTSTHREECOL]: SECTION_TYPES.PRODUCTSTHREECOL,
    [SECTION_TYPES.PRODUCTSTWOCOL]: SECTION_TYPES.PRODUCTSTWOCOL,
  },
  [ITEM_TYPE_RESPONDER]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.ONECOL]: SECTION_TYPES.ONECOL,
    [SECTION_TYPES.TWOCOL]: SECTION_TYPES.TWOCOL,
    [SECTION_TYPES.THREECOL]: SECTION_TYPES.THREECOL,
  },
  [ITEM_TYPE_PAGE]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.ONECOL]: SECTION_TYPES.ONECOL,
    [SECTION_TYPES.TWOCOL]: SECTION_TYPES.TWOCOL,
  },
  [ITEM_TYPE_LANDING_PAGE]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.LANDINGONECOL]: SECTION_TYPES.LANDINGONECOL,
    [SECTION_TYPES.LANDINGTWOCOL]: SECTION_TYPES.LANDINGTWOCOL,
  },
  [ITEM_TYPE_LANDING_PAGE_SUCCESS]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.LANDINGONECOL]: SECTION_TYPES.LANDINGONECOL,
    [SECTION_TYPES.LANDINGTWOCOL]: SECTION_TYPES.LANDINGTWOCOL,
  },
  [ITEM_TYPE_FORM]: {},
  [ITEM_TYPE_FORM_SUBTYPE_SUCCESS]: {},
  [ITEM_TYPE_SURVEY]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.ONECOL]: SECTION_TYPES.ONECOL,
  },
  [ITEM_TYPE_SURVEY_THANK_YOU]: {
    [SECTION_TYPES.NULL]: SECTION_TYPES.NULL,
    [SECTION_TYPES.ONECOL]: SECTION_TYPES.ONECOL,
    [SECTION_TYPES.TWOCOL]: SECTION_TYPES.TWOCOL,
  },
}

export const BLOCK_FIELDS_PER_ITEM_TYPE = {
  [ITEM_TYPE_SURVEY]: {
    [FIELD_TYPES.NULL]: FIELD_TYPES.NULL,
    [FIELD_TYPES.SHORT_TEXT]: FIELD_TYPES.SHORT_TEXT,
    [FIELD_TYPES.LONG_TEXT]: FIELD_TYPES.LONG_TEXT,
    [FIELD_TYPES.SELECT_ONE]: FIELD_TYPES.SELECT_ONE,
    [FIELD_TYPES.SELECT_MANY]: FIELD_TYPES.SELECT_MANY,
    [FIELD_TYPES.SCALE]: FIELD_TYPES.SCALE,
  }
}

export const BLOCK_TYPES_SETTINGS_ENABLED = {
  [BLOCK_TYPES.NULL]: true,
  [BLOCK_TYPES.SECTION]: true,
  [BLOCK_TYPES.TEXT]: true,
  [BLOCK_TYPES.IMAGE]: true,
  [BLOCK_TYPES.VIDEO]: true,
  [BLOCK_TYPES.SHARE]: false,
  [BLOCK_TYPES.FOLLOW]: false,
  [BLOCK_TYPES.SHARE_V2]: true,
  [BLOCK_TYPES.FOLLOW_V2]: true,
  [BLOCK_TYPES.BUTTON]: true,
  [BLOCK_TYPES.SIMPLE_BUTTON]: true,
  [BLOCK_TYPES.SUBMIT_BUTTON]: true,
  [BLOCK_TYPES.CONFIRM_BUTTON]: true,
  [BLOCK_TYPES.SPACING]: true,
  [BLOCK_TYPES.DIVIDER]: true,
  [BLOCK_TYPES.HTML]: true,
  [BLOCK_TYPES.FORM]: true,
  [BLOCK_TYPES.FIELD]: true,
  [BLOCK_TYPES.TIMER]: true,
  [BLOCK_TYPES.BANNER]: true,
  [BLOCK_TYPES.PRODUCT]: true,
}

export const BLOCK_ICONS = {
  [BLOCK_TYPES.HTML]: 'assets/img/block-html.svg',
  [BLOCK_TYPES.TEXT]: 'assets/img/block-text.svg',
  [BLOCK_TYPES.IMAGE]: 'assets/img/block-image.svg',
  [BLOCK_TYPES.VIDEO]: 'assets/img/block-video.svg',
  [BLOCK_TYPES.BUTTON]: 'assets/img/block-button.svg',
  [BLOCK_TYPES.SIMPLE_BUTTON]: 'assets/img/block-button.svg',
  [BLOCK_TYPES.SUBMIT_BUTTON]: 'assets/img/block-button.svg',
  [BLOCK_TYPES.CONFIRM_BUTTON]: 'assets/img/block-button.svg',
  [BLOCK_TYPES.SHARE]: 'assets/img/block-socialShareV3.svg',
  [BLOCK_TYPES.FOLLOW]: 'assets/img/block-socialFollowV3.svg',
  [BLOCK_TYPES.SHARE_V2]: 'assets/img/block-socialShareV3.svg',
  [BLOCK_TYPES.FOLLOW_V2]: 'assets/img/block-socialFollowV3.svg',
  [BLOCK_TYPES.SPACING]: 'assets/img/block-spacing.svg',
  [BLOCK_TYPES.DIVIDER]: 'assets/img/block-divider.svg',
  [BLOCK_TYPES.FORM]: 'assets/img/block-html.svg',
  [BLOCK_TYPES.TIMER]: 'assets/img/block-countdown.svg',
  [BLOCK_TYPES.BANNER]: 'assets/img/block-banner.svg',
  [SECTION_TYPES.ONECOL]: 'assets/img/section-onecol.svg',
  [SECTION_TYPES.TWOCOL]: 'assets/img/section-twocol.svg',
  [SECTION_TYPES.THREECOL]: 'assets/img/section-threecol.svg',
  [SECTION_TYPES.LANDINGONECOL]: 'assets/img/section-onecol.svg',
  [SECTION_TYPES.LANDINGTWOCOL]: 'assets/img/section-twocol.svg',
  [SECTION_TYPES.PRODUCTSTHREECOL]: 'assets/img/block-products.svg',
  [SECTION_TYPES.PRODUCTSTWOCOL]: 'assets/img/block-products.svg',
  [FIELD_TYPES.SHORT_TEXT]: 'assets/img/survey-short_text.svg',
  [FIELD_TYPES.LONG_TEXT]: 'assets/img/survey-long_text.svg',
  [FIELD_TYPES.SELECT_ONE]: 'assets/img/survey-select_one.svg',
  [FIELD_TYPES.SELECT_MANY]: 'assets/img/survey-select_many.svg',
  [FIELD_TYPES.SCALE]: 'assets/img/survey-scale.svg',
}

export const DEFAULT_PADDING = 20

export const MAX_BUTTON_HEIGHT = 602
export const MAX_BUTTON_BORDER_RADIUS = 602
export const MAX_SECTION_BORDER_RADIUS = 100

export const MAX_SECTION_PADDING = 100
export const MIN_WIDTH = 10
export const MIN_HEIGHT = 10
